import { journeySuppress } from './journey.js';

// PARAQTA — Оверлей кезегі: БІР УАҚЫТТА БІР НӘРСЕ.
//
// Мәселе (2026-08-11 founder): жаңа адамға онбординг, PWA орнату парағы,
// логин терезесі, мереке және баннерлер бір-бірінен ХАБАРСЫЗ, әрқайсысы
// өз таймерімен шығатын (0.9с · 1.8с · 4.5с) — сондықтан бірінің үстіне
// бірі қабаттасатын, әрі кім бірінші шығатыны интернет жылдамдығына
// байланысты әр адамда әртүрлі болатын.
//
// Шешім: барлық оверлей осы кезекке ТІРКЕЛЕДІ. Біреуі ашық тұрса,
// қалғандары кезекте күтеді де, ол жабылғанда кезекпен шығады.
// Ешқашан біреуінің үстіне екіншісі шықпайды.
//
// Қолданысы:
//   claim('pwa', () => openSheet())   → орын бос болса ашады, болмаса кезекке
//   release('pwa')                    → жабылғанда МІНДЕТТІ түрде шақыр
//   busy()                            → қазір бірдеңе ашық па
//   afterGate(fn)                     → онбординг шешімі белгілі болғанда

// Кіші сан = жоғары басымдық.
const PRIORITY = {
  onboarding: 10,   // ең маңыздысы — үзілмейді
  comeback: 12,     // 02.11 онбординг 0: «Қайта келдің» / «Шырағың сөніп қалыпты» (features/onboarding0)
  onboarding1: 11, // 02.11 онбординг 1: «Алғашқы 90 секунд» қадамдары (features/onboarding1)
  login: 20,        // адамның өз әрекетінен туады
  journey: 25,      // ?journey=1: сессия соңындағы кітапханашы парағы (мереке орнына)
  celebration: 30,  // мереке — сәтінде көрінуі керек
  channel: 40,      // «қайда жазайын?» — тіркелгеннен кейінгі арна қадамы
  push: 55,         // хабарлама рұқсаты
  pwa: 60,          // орнату ұсынысы — асығыс емес
  banner: 80,       // ескерту баннерлері
};

let _active = null;              // ашық тұрған оверлей аты
const _queue = [];               // [{ name, show, p }]
let _gateOpen = false;           // онбординг шешімі белгілі ме
const _gateWaiters = [];

function _next() {
  const item = _queue.shift();
  if (!item) { _active = null; return; }
  _active = item.name;
  // Кішкене үзіліс — экран «секірмейді», адам алдыңғысының жабылғанын көреді.
  setTimeout(() => {
    try { item.show(); } catch (_) { release(item.name); }
  }, 260);
}

/** Оверлейге орын сұрау. true = бірден ашылды, false = кезекке тұрды. */
export function claim(name, show) {
  if (typeof show !== 'function') return false;
  if (_active === name) return true;                    // әлдеқашан ашық
  if (_queue.some(x => x.name === name)) return false;  // кезекте тұр
  if (_active) {
    _queue.push({ name, show, p: PRIORITY[name] ?? 50 });
    _queue.sort((a, b) => a.p - b.p);
    return false;
  }
  _active = name;
  try { show(); } catch (_) { _active = null; }
  return true;
}

/** Оверлей жабылды — келесісін жіберу. */
export function release(name) {
  if (_active !== name) {
    const i = _queue.findIndex(x => x.name === name);
    if (i >= 0) _queue.splice(i, 1);
    return;
  }
  _active = null;
  _next();
}

// ── «Бөгеу» (hold) ────────────────────────────────────────────────
// Адамның ӨЗ әрекетінен ашылатындар (логин терезесі, мереке) кезекте
// күтпейді — бірден ашылады. Бірақ ашық тұрғанда үстіне ЕШНӘРСЕ шықпауы
// үшін кезекті бөгеп қояды.
const _holds = new Set();

export function busyStart(name) {
  _holds.add(name);
  if (!_active) _active = '#hold:' + name;
}

export function busyEnd(name) {
  _holds.delete(name);
  if (_active === '#hold:' + name) { _active = null; _next(); }
}

/** Қазір бірдеңе ашық па. */
export function busy() { return _active !== null || _holds.size > 0; }

/** Не ашық (диагностика). */
export function activeOverlay() { return _active; }

/** Онбординг шешімі белгілі болды (көрсетілді не керек емес). */
export function openGate() {
  if (_gateOpen) return;
  _gateOpen = true;
  _gateWaiters.splice(0).forEach((fn) => { try { fn(); } catch (_) {} });
}

/** Онбординг шешімінен КЕЙІН ғана орындау (PWA-ның ерте шығуын болдырмау). */
export function afterGate(fn) {
  if (_gateOpen) { try { fn(); } catch (_) {} return; }
  _gateWaiters.push(fn);
}

// ── ЕКІНШІЛІК ТЕРЕЗЕЛЕР (22.09 founder ережесі) ──────────────────
// Арна, push, PWA — үшеуі де адамға БІРДЕҢЕ БЕРМЕЙДІ, одан сұрайды.
// Сондықтан екі шарт: (1) адам бірінші оқу сессиясын БІТІРГЕН болсын,
// (2) тәулігіне біреуден артық сұралмасын.
//
// Бұған дейін үшеуі де жаңа адамға бірінші минутта шығатын. Қыркүйекте
// 1 100 адам тіркеліп, 256-сы ғана бір бет оқыды.

const SESS_KEY = 'pq_sess_done';
const DAY_KEY = 'pq_overlay_day';
let _sessionDone = false;

/** Бірінші сессия бітті (oqu шақырады, әрі ескі қолданушыға stats-тан). */
export function markSessionDone() {
  _sessionDone = true;
  try { localStorage.setItem(SESS_KEY, '1'); } catch (_) {}
}

export function hasSession() {
  if (_sessionDone) return true;
  try { return !!localStorage.getItem(SESS_KEY); } catch (_) { return false; }
}

function _today() {
  const d = new Date();
  return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
}

/** Сұрайтын терезелер осы арқылы ғана шығады. */
export function claimSecondary(name, show) {
  if (!hasSession()) return false;
  // ?journey=1: алғашқы 3 күнде арна/push/PWA шықпайды (мұнда ұсталады, 4-күні өздігінен шығады — ештеңе жоғалмайды)
  try { if (journeySuppress()) return false; } catch (_) {}
  try { if (localStorage.getItem(DAY_KEY) === _today()) return false; } catch (_) {}
  return claim(name, () => {
    try { localStorage.setItem(DAY_KEY, _today()); } catch (_) {}
    show();
  });
}

// Қорғаныс: онбординг шешімі бір себеппен келмей қалса, сайт «қатып»
// қалмас үшін 12 секундтан соң қақпа өзі ашылады.
setTimeout(openGate, 12000);
